import {EXCEL_MIME_TYPES} from '../../utils/extensions';
import IOrganizationApi from '../../api/organization-api.service';
import {ITemplateTagsResponse} from '../../api/api.types';
import IUploadService = angular.angularFileUpload.IUploadService;
import {IImomoErrorService} from '../../error/error.service';
import {IOrganizationDetailsStateParams} from './organization.controller'

enum IDataFileState {
  Unselected, Selected, Validating, Invalid, Valid
}

export default class ReportingTemplatesController {
	static $inject = ['organizationApi', 'Upload', '$translate', 'imomoErrorService', '$stateParams'];

	private decadalBulletinDataFile:File;
	private decadalBulletinDataFileState:IDataFileState = IDataFileState.Unselected;

	private dailyBulletinDataFile:File;
	private dailyBulletinDataFileState:IDataFileState = IDataFileState.Unselected;

	private dailyBulletintemplateTags: ITemplateTagsResponse;
	private decadalBulletintemplateTags: ITemplateTagsResponse;
	private showDailyTags: boolean = false;
	private showDecadalTags: boolean = false;

	private dailyBulletinTemplateUrl: string;
	private decadalBulletinTemplateUrl: string;

	private dailyBulletinTemplateUrlCurrent: string;
	private decadalBulletinTemplateUrlCurrent: string;

	private dailyBulletinTemplateError: string;
	private decadalBulletinTemplateError: string;

	private isLoading: boolean = false;
	constructor (
		private organizationApi: IOrganizationApi,
		private Upload:IUploadService,
		private $translate:ng.translate.ITranslateService,
		private imomoErrorService: IImomoErrorService,
		private $stateParams: IOrganizationDetailsStateParams
	) {
		this.organizationApi.getReportingTemplateTags('daily_bulletin')
			.then((tags) => {
				this.dailyBulletintemplateTags = tags;
			})
		this.organizationApi.getReportingTemplateTags('decadal_bulletin')
			.then((tags) => {
				this.decadalBulletintemplateTags = tags;
			})

		this.organizationApi.getReportingTemplateDefault('daily_bulletin')
			.then((url) => {
				this.dailyBulletinTemplateUrl = url;
			})

		this.organizationApi.getReportingTemplateDefault('decadal_bulletin')
			.then((url) => {
				this.decadalBulletinTemplateUrl = url;
			})

		if (this.$stateParams.id !== 'new') {
			this.fetchCurrentDailyTemplate();
			this.fetchCurrentDecadalTemplate();
		}
	}

	get excelMimeTypes() {
	  return EXCEL_MIME_TYPES;
	}

	get isDecadalBulletinDataFileUnselected() {
	  return this.decadalBulletinDataFileState == IDataFileState.Unselected;
	}

	get isDailyBulletinDataFileUnselected() {
	  return this.dailyBulletinDataFileState == IDataFileState.Unselected;
	}

	private fetchCurrentDailyTemplate() {
		this.organizationApi.getReportingTemplate('daily_bulletin')
			.then((data) => {
				this.dailyBulletinTemplateUrlCurrent = data.templateUrl;
			})
	}

	private fetchCurrentDecadalTemplate() {
		this.organizationApi.getReportingTemplate('decadal_bulletin')
			.then((data) => {
				this.decadalBulletinTemplateUrlCurrent = data.templateUrl;
			})
	}

	private onUploadTemplate(reportType: string) {
		const language = this.$translate.proposedLanguage()
		this.isLoading = true;
		if (reportType === 'daily_bulletin') {
			this.Upload.base64DataUrl(this.dailyBulletinDataFile)
			  .then((base64String) => {
			  	this.organizationApi.saveReportingTemplate('daily_bulletin', {
			  		language: language,
			  		templateFileBase64: base64String
			  	}).then(() => {
			  		this.dailyBulletinDataFileState = IDataFileState.Unselected;
			  		this.dailyBulletinDataFile = null;
			  		this.dailyBulletinTemplateError = null;
			  		this.isLoading = false;
			  		this.fetchCurrentDailyTemplate();
			  	}).catch((error) => {
			  		//this.imomoErrorService.showErrorDetailsDialog(error.data.details);
			  		this.dailyBulletinTemplateError = error.data.details;
			  		this.isLoading = false;
			  	})
			  })
		} else if (reportType === 'decadal_bulletin') {
			this.Upload.base64DataUrl(this.decadalBulletinDataFile)
			  .then((base64String) => {
			  	this.organizationApi.saveReportingTemplate('decadal_bulletin', {
			  		language: language,
			  		templateFileBase64: base64String
			  	}).then(() => {
			  		this.decadalBulletinDataFileState = IDataFileState.Unselected;
			  		this.decadalBulletinDataFile = null;
			  		this.decadalBulletinTemplateError = null;
			  		this.isLoading = false;
					this.fetchCurrentDecadalTemplate();
			  	}).catch((error) => {
			  		//this.imomoErrorService.showErrorDetailsDialog(error.data.details);
			  		this.decadalBulletinTemplateError = error.data.details;
			  		this.isLoading = false;
			  	})
			  })
		}
		
	}

	private onDeleteTemplate(reportType: string) {
		this.isLoading = true;
		this.organizationApi.deleteReportingTemplate(reportType)
			.then(() => {
				if (reportType === 'daily_bulletin') {
					this.dailyBulletinTemplateUrlCurrent = null;
				}
				if (reportType === 'decadal_bulletin') {
					this.decadalBulletinTemplateUrlCurrent = null;
				}
				
				this.isLoading = false;
			})
			.finally(() => {
				this.isLoading = false;
			});
	}

	onDecadalTemplateDataFileChange = (files:Array<File>) => {
	  if (files && files[0]) {
	    this.decadalBulletinDataFile = files[0];
	    this.decadalBulletinDataFileState = IDataFileState.Selected;
	  } else {
	    this.decadalBulletinDataFileState = IDataFileState.Unselected;
	    this.decadalBulletinDataFile = null;
	  }
	};

	onDailyTemplateDataFileChange = (files:Array<File>) => {
	  if (files && files[0]) {
	    this.dailyBulletinDataFile = files[0];
	    this.dailyBulletinDataFileState = IDataFileState.Selected;
	  } else {
	    this.dailyBulletinDataFileState = IDataFileState.Unselected;
	    this.dailyBulletinDataFile = null;
	  }
	};
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/organization/reporting-templates.controller.ts
 **/